/*
  Karuzela dwuwierszowa dla sekcji produktowych.

  Kazdy wiersz to osobna karuzela z wlasna para strzalek — przewijaja sie
  niezaleznie. Po dojsciu do konca kolejne klikniecie wraca na poczatek
  (i odwrotnie), wiec listy zapetlaja sie i strzalki nigdy nie sa martwe.

  Dlaczego wlasny skrypt zamiast slidera z motywu:
  - slider-component liczy pozycje z ukladu flex w JEDNEJ linii, wiec przy
    dwoch wierszach dawal "NaN / z -Infinity" i nie przewijal,
  - tor ma animacje pojawiania sie `slideIn`, ktora steruje `transform`,
    a animacja CSS bije styl inline; dlatego przesuwamy wlasciwoscia
    `translate`, ktorej ta animacja nie dotyka.

  Na telefonie nie ruszamy niczego — tam dziala natywny slider motywu.
*/
(function () {
  var MIN_DESKTOP = '(min-width: 990px)';
  var COLUMNS = 6;
  var ROWS = 2;

  function build(slider) {
    if (slider.dataset.gzSlider === '1') return;
    if (!window.matchMedia(MIN_DESKTOP).matches) return;
    // Cart page keeps a single sliding row — two rows of recommendations would
    // outweigh the order itself. It still goes through this script rather than
    // Dawn's slider, because paging by a whole screen is what stops the last
    // card being sliced in half.
    var rowCount = document.body.classList.contains('template-cart') ? 1 : ROWS;

    var track = slider.querySelector('.slider');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('.grid__item'));
    if (items.length <= COLUMNS) return;

    var templatePrev = slider.querySelector('.slider-button--prev');
    var templateNext = slider.querySelector('.slider-button--next');
    if (!templatePrev || !templateNext) return;

    slider.dataset.gzSlider = '1';

    var perRow = Math.ceil(items.length / rowCount);
    var groups = [];
    for (var g = 0; g < rowCount; g++) {
      groups.push(items.slice(g * perRow, (g + 1) * perRow));
    }

    var container = document.createElement('div');
    container.className = 'gz-rows';

    groups.forEach(function (group) {
      if (!group.length) return;

      var row = document.createElement('div');
      row.className = 'gz-row';

      // Okno przycinajace MUSI byc osobnym elementem od tego, ktory sie
      // przesuwa. Gdy przesuwalismy sam tor, jego obszar przyciecia jechal
      // razem z kafelkami i te wysypywaly sie poza container.
      var clip = document.createElement('div');
      clip.className = 'gz-row__viewport';

      var rowTrack = document.createElement('div');
      rowTrack.className = 'gz-row__track';
      group.forEach(function (it) {
        it.style.width = '';
        rowTrack.appendChild(it);
      });
      clip.appendChild(rowTrack);

      var prev = templatePrev.cloneNode(true);
      var next = templateNext.cloneNode(true);
      prev.classList.add('gz-row__btn', 'gz-row__btn--prev');
      next.classList.add('gz-row__btn', 'gz-row__btn--next');
      prev.removeAttribute('id');
      next.removeAttribute('id');
      prev.disabled = false;
      next.disabled = false;

      row.appendChild(prev);
      row.appendChild(clip);
      row.appendChild(next);
      container.appendChild(row);

      var offset = 0;

      function pageWidth() {
        return Math.max(clip.clientWidth, 1);
      }

      // Nadmiar tresci nad oknem — ostatnia pozycja konczy sie rowno
      // z krawedzia, zamiast przewijac w pustke.
      function maxOffset() {
        return Math.max(rowTrack.scrollWidth - clip.clientWidth, 0);
      }

      // Tor ma width:max-content, wiec procenty w szerokosci kafelka nie maja
      // sie do czego odniesc — podajemy szerokosc okna jawnie zmienna CSS.
      function refreshWidths() {
        rowTrack.style.setProperty('--gz-viewport', clip.clientWidth + 'px');
        // The arrows sit on the card image, not on the whole tile — centring on
        // the tile drops them onto the title. The image is square, so half the
        // card width is its middle.
        var firstCard = rowTrack.querySelector('.grid__item');
        if (firstCard) {
          row.style.setProperty('--gz-card', firstCard.offsetWidth + 'px');
        }
      }

      function moveTo(x) {
        refreshWidths();
        offset = Math.min(Math.max(x, 0), maxOffset());
        rowTrack.style.translate = -offset + 'px';
      }

      next.addEventListener('click', function () {
        // na koncu wracamy na poczatek
        moveTo(offset >= maxOffset() - 1 ? 0 : offset + pageWidth());
      });
      prev.addEventListener('click', function () {
        // na poczatku skaczemy na koniec
        moveTo(offset <= 1 ? maxOffset() : offset - pageWidth());
      });

      window.addEventListener('resize', function () { moveTo(offset); });
      requestAnimationFrame(function () { refreshWidths(); moveTo(0); });
    });

    track.parentNode.insertBefore(container, track);
    track.remove();

    var legacyButtons = slider.querySelector('.slider-buttons');
    if (legacyButtons) legacyButtons.remove();
  }

  function buildAll() {
    document
      .querySelectorAll('slider-component.slider-component-desktop')
      .forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAll);
  } else {
    buildAll();
  }
  document.addEventListener('shopify:section:load', buildAll);
})();
